import React from 'react';
import { Input, Button, Select } from 'components';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, checkPermission } from 'utils';
import { ReferralService } from 'services';

interface Props {
	onClose?: any;
	referral_amounts?: any;
}

class ModalAmount extends React.Component<Props> {

	state = {
		items: [...this.props.referral_amounts]
	}

	submit = async () => {
		await ReferralService.admin.updateAmount({
			items: JSON.stringify(this.state.items)
		});
		this.props.onClose();
	}

	change = (e: any,index: number) => {
		let items: any = [...this.state.items];
		items[index][e.target.name] = e.target.value;
		this.setState({
			items
		});
	}
	
	render() {
		return (
			<div id="modal-referral-amount">
				{
					this.state.items?.map((item: any, index: number) => {
						return (
							<>
								<p className="country-name">{ item?.country?.name }</p>
								<hr />
								<Input
									type="decimal"
									value={ item?.amount }
									name="amount"
									label="Monto de pago al cumplirse la meta ($)"
									onChange={ (e: any) => this.change(e,index) } />
								<Input
									type="number"
									value={ item?.quantity }
									name="quantity"
									label="Cantidad de referidos para que la regla se cumpla"
									onChange={ (e: any) => this.change(e,index) } />
							</>
						)
					})
				}
				<div className="text-center">
					<Button type="submit" className="btn-save" onClick={ () => this.submit() }>
						Guardar
					</Button>
				</div>
			</div>
		)
	}
}

export default ModalAmount;